import { render, staticRenderFns } from "./DuplicateEventModal.vue?vue&type=template&id=2edfe6c4"
import script from "./DuplicateEventModal.vue?vue&type=script&lang=js"
export * from "./DuplicateEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports